import { render, staticRenderFns } from "./onebox-loginbydomain.vue?vue&type=template&id=0b849c10&"
import script from "./onebox-loginbydomain.vue?vue&type=script&lang=js&"
export * from "./onebox-loginbydomain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports